import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { Layout } from '../components';
import { PrivateRoute } from '.';

import { 
  LandingPage,
  Login,
  SignUpForm,
  ForgotPassword,
  RegisterSuccess,
  NewPassword,
  ForgotPasswordSuccess,
  Welcome,
  Profile,
  Schedule,
  AdminPanel,
  WorkerPanel,
} from '../screens';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Rotas públicas */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<SignUpForm />} />
      <Route path="/register-success" element={<RegisterSuccess />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<NewPassword />} />
      <Route path="/success-password" element={<ForgotPasswordSuccess />} />

      {/* Rotas privadas */}
      <Route path="/home" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Welcome />}/>
        <Route path="profile" element={<Profile />} /> {/* /home/profile */}
        <Route path="schedule" element={<Schedule />} /> {/* /home/schedule */}
        <Route path="admin" element={<AdminPanel />} /> {/* /home/admin */}
        <Route path="worker" element={<WorkerPanel />} /> {/* /home/worker */}
      </Route>
    </Routes>
  );
}
      